import { AxiosResponse } from "axios";
import { api } from "../api";

export default async function getWalletInsights(): Promise<AxiosResponse> {
  try {
    const response = await api.get("/user/wallet/insights");

    return response;
  } catch (err: any) {
    console.log(err);

    return err.response;
  }
}
